import React from "react";

export default class Shock extends React.Component {
  render() {
    return (
      <>
        <h3>Symptoms:</h3>
        <p>
          Fast and weak pulse, pale face, cold sweat, desorientation, sometimes
          nausea.{" "}
        </p>
        <h3>What to do?</h3>
        <ul>
          <li>
            Lay the person flat on their back and check conciousness and
            breathing.{" "}
          </li>
          <li>
            If breathing but unconcious raise the legs high and hold about 1-2
            minutes, if there is a chance or somebody can help you, hold up the
            arms too. If after 2 minutes the conciousness is not back, check
            breathing again.{" "}
          </li>
          <li>
            If is breathing, lay the person down in a safe position and monitor
            life functions and call for help!
          </li>
          <li>
            If not breathing, call a medical rescue team and immiedietly begin
            cardio-vascular resuscitation (see CARDIAC ARREST)
          </li>
        </ul>
      </>
    );
  }
}
